import { Fullscreen } from "lucide-react";
import { Input, DefaultTooltip, ToggleOptionGroup, ToggleOptionGroupItem } from "twyne-new.ui";

import { useCraftProp } from "../utils";

export default function GridCountProperty({ name, fullOption }) {
  const { value, setValue } = useCraftProp(name)

  return <>
    <div className='flex items-center justify-between gap-1'>
      <Input
        value={Number(value) || ''}
        onChange={e => setValue(Number(e.target.value))}
        type="number"
        variant='accent'
        disabled={value === 'full'}
      />
      {fullOption && <>
        <ToggleOptionGroup value={value === 'full' ? 'show' : ''} type='single' onValueChange={() => setValue(value === 'full' ? null : 'full')}>
          <ToggleOptionGroupItem value='show'>
            <DefaultTooltip content='Span Full' triggerProps={{ className: 'w-full flex justify-center' }}>
              <Fullscreen size='16' />
            </DefaultTooltip>
          </ToggleOptionGroupItem>
        </ToggleOptionGroup>
      </>}
    </div>
  </>
}
